import { BaseClient } from '@/api'
import request from '@/utils/request'

export class StationDynamicClient extends BaseClient {
  constructor() {
    super('station-dynamics')
  }

  async downloadExcel(params: any): Promise<any> {
    return request({
      url: '/station-dynamics-download-excel',
      method: 'get',
      params,
      responseType: 'arraybuffer'
    })
  }
}
